export default "__VITE_ASSET__BJpjxnaY__"